import {
    MutableRefObject,
    useEffect,
    useState,
} from 'react'
import {
    Checkbox,
} from '@mui/material'

import {
    GridRadioCell,
} from 'app/shared-components/SkyBaseDataGrid/components'
import {
    ExtendedGridApiPro,
} from 'app/shared-components/SkyBaseDataGrid'
import {
    SelectionType,
} from '../../SkyNetDataGrid'

type Props = {
    rowId: number | string
    selectionType?: SelectionType
    onRadioChange: (id: number | string) => void
    onCheckboxChange: (id: number | string) => void
    apiRef: MutableRefObject<ExtendedGridApiPro>
    initiallyDisabled: boolean
}

const SelectionCell = ({
    rowId,
    selectionType,
    onRadioChange,
    onCheckboxChange,
    apiRef,
    initiallyDisabled,
}: Readonly<Props>) => {
    const [
        checked,
        setChecked,
    ] = useState(() => {
        return apiRef.current?.getSelectedRows()?.has(rowId) ?? false
    })

    const [
        disabled,
        setDisabled,
    ] = useState(initiallyDisabled)

    useEffect(() => {
        const unsubscribeSelectionChange = apiRef.current?.subscribeEvent('rowSelectionChange', () => {
            const isSelected = apiRef.current?.getSelectedRows()?.has(rowId) ?? false

            setChecked(isSelected)
        })

        const unsubscribeDisabledChange = apiRef.current?.subscribeEvent?.('disabledStateChange' as any, (newDisabled: boolean) => {
            setDisabled(newDisabled)
        })

        return () => {
            unsubscribeSelectionChange?.()
            unsubscribeDisabledChange?.()
        }
    }, [
        apiRef,
        rowId,
    ])

    if (selectionType === SelectionType.Radio) {
        return (
            <GridRadioCell
                checked={checked}
                disabled={disabled}
                onChange={() => {
                    onRadioChange(rowId)
                }}
            />
        )
    }

    return (
        <Checkbox
            checked={checked}
            disabled={disabled}
            onChange={() => {
                onCheckboxChange(rowId)
            }}
        />
    )
}

export default SelectionCell
